import { ICalType } from 'models/ICal';
import * as Yup from 'yup';
import { OptionalObjectSchema } from 'yup/lib/object';

export const calendarImportFormSchema = () => ({
  url: Yup.string().required(),
  type: Yup.mixed<ICalType>().oneOf(Object.values(ICalType)).required(),
  property: Yup.string().required(),
  name: Yup.string().when('type', {
    is: ICalType.DEFAULT,
    then: Yup.string().required(),
    otherwise: Yup.string(),
  }),
  synchronizeAfterCreation: Yup.boolean().required(),
});

export type CalendarImportFormValues = Yup.InferType<
  OptionalObjectSchema<ReturnType<typeof calendarImportFormSchema>>
>;
